import React from "react";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom";
import AmpAccordian from "../components/common/AmpAccordian/AmpAccordian";
import Fab from "../components/common/AmpFloatingActionButton/AmpFloatingActionButton";
import AmpFooter from "../components/common/AmpFooter/AmpFooter";
import AmpQuestions from "../components/common/AmpQuestions/AmpQuestions";
import HeaderNav from "../components/common/HeaderNav/HeaderNav";
import LanguageAccessibilty from "../components/common/LanguageAccessibility/LanguageAccessibilty";
import Logo from "../components/common/Logo/Logo";
import "./Layout.css"

function Login(): JSX.Element {

  const { t } = useTranslation(['login']);

  // const dispatch = useDispatch();

  // useEffect(() => {
  //   // dispatch(changeModalState("modal-dismiss"));
  // // eslint-disable-next-line
  // }, []);

  return (
    <div className={"root-login-layout login"}>
      <div className={"logo-nav-header"}>
        <div className="logo-parent">
          <Logo isNewImage/>
        </div>
        <LanguageAccessibilty />
      </div>
      <div className={"header-second-row"}>
        <HeaderNav isAuthed={false}></HeaderNav>
      </div>
      <div className="blue-bar-header"></div>
      <Outlet />
      <div className="questions-login-blue-bar span-page-blue-bar" />
      <aside className="questions-rows-login" aria-labelledby="amp-questions">
        <AmpQuestions belowHeaderContent={
          <p className="amp-questions-caption">{t("below-have-qs") as string}</p>
        } questions={
          [
            <AmpAccordian key={1} title={t("what-is-amp")} content={t("what-is-amp-content")} />,
            <AmpAccordian key={2} title={t("what-is-info-amp")} content={t("what-is-info-amp-content")} />,
            <AmpAccordian key={3} title={t("how-register")} content={t("how-register-content")} />,
            <p key={4}>{t("no-notice") as string} <Link className="amp-anchor" to="/auth/contact-us">{t("contact-us")}</Link></p>,
            <p key={5}>{t("help-register") as string}</p>,
            <p key={6}>{t("supported-browser") as string}</p>
          ]
        } />
      </aside>
      <AmpFooter/>
      <Fab elementScrollQuery={".root-login-layout > *:nth-child(4)"}>Scroll to Content</Fab>
    </div>
  );
}

export default Login;